import type { ProviderToken } from '@angular/core';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

import type { WalkthroughServiceI } from '@core/walkthrough-legacy';

export const activateWalkthrough =
  (walkthroughServiceToken: ProviderToken<WalkthroughServiceI>, redirectTo: string) => () => {
    const router = inject(Router);
    const serviceInstance = inject(walkthroughServiceToken);
    serviceInstance.start();
    return router.parseUrl(redirectTo);
  };
